/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Moment from 'react-moment';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ElectroDatePicker from 'forms/components/inputs/ElectroDatePicker/ElectroDatePicker';
import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  asset: Object,
  form: TypeForm,
};

@translate()
@observer
export default class ExtendRentalForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, asset, form }: TypeProps = this.props;

    let details: Array<*> = [
      [t('general:assets.labels.number'), asset.asset_number],
      [t('general:manufacturer'), asset.manufacturer],
      [t('general:model'), asset.model],
      [t('general:labels.serial_number'), asset.serial_number],
    ];

    if (asset.contract) {
      details = [
        [t('general:trading_account'), `${asset.account.name} ${asset.account.number}`],
        [t('general:contracts.labels.number'), asset.contract.er_contract_number],
        [t('general:labels.po_number'), asset.contract.er_po_number],
        [
          t('general:labels.expected_end_date'),
          <Moment
            key="end_date"
            date={asset.contract.er_expected_end_date}
            format="MMMM DD, YYYY"
          />,
        ],
      ].concat(details);
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.labels.details')}
          >
            <ActionDrawerTable data={details} />
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('extendDetails').label}>
            <ElectroDatePicker
              field={form.$('extendDetails.endDate')}
              minDate={form.$('extendDetails.endDate').value}
            />
            <ElectroSelectWithOther
              field={form.$('extendDetails.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
            <ElectroTextField field={form.$('extendDetails.newPONumber')} />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.extend')} />
      </React.Fragment>
    );
  }
}
